export const S = {
  label: { display:'block', fontSize:12, fontWeight:500, color:'#6b7280', marginBottom:5 },
  input: { width:'100%', padding:'8px 11px', border:'1px solid #e5e7eb', borderRadius:7, fontSize:13, boxSizing:'border-box', outline:'none', background:'#fff' },
  btn: { padding:'8px 16px', borderRadius:7, fontSize:13, fontWeight:500, cursor:'pointer', border:'none' },
  btnPrimary: { padding:'8px 16px', borderRadius:7, fontSize:13, fontWeight:500, cursor:'pointer', border:'none', background:'#3b82f6', color:'#fff' },
  btnSecondary: { padding:'8px 16px', borderRadius:7, fontSize:13, fontWeight:500, cursor:'pointer', border:'1px solid #e5e7eb', background:'#f9fafb', color:'#374151' },
  btnDanger: { padding:'8px 16px', borderRadius:7, fontSize:13, fontWeight:500, cursor:'pointer', border:'none', background:'#fef2f2', color:'#ef4444' },
  btnSm: { padding:'5px 11px', borderRadius:6, fontSize:12, fontWeight:500, cursor:'pointer', border:'none' },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,.45)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, backdropFilter:'blur(2px)' },
  modal: { background:'#fff', borderRadius:12, padding:28, width:620, maxHeight:'90vh', overflowY:'auto', boxShadow:'0 20px 60px rgba(0,0,0,.2)' },
  card: { background:'#fff', border:'1px solid #e5e7eb', borderRadius:10, padding:20 },
  th: { padding:'10px 14px', textAlign:'left', fontSize:11, fontWeight:600, color:'#9ca3af', textTransform:'uppercase', letterSpacing:.5, background:'#f9fafb', whiteSpace:'nowrap' },
  td: { padding:'11px 14px', fontSize:13, borderBottom:'1px solid #f3f4f6' },
};

export const REGIONS = ['Middle East','Europe','USA','UK','India','Other'];
export const CURRENCIES = ['USD','EUR','INR'];
export const NOTE_CATS = ['Customer Instruction','Internal Mistake','Vendor Issue','Quality Issue','Delay Reason','General'];
export const NOTE_COLORS = {
  'Customer Instruction': { bg:'#eff6ff', color:'#3b82f6', border:'#3b82f6' },
  'Internal Mistake': { bg:'#fef2f2', color:'#ef4444', border:'#ef4444' },
  'Vendor Issue': { bg:'#fff7ed', color:'#f97316', border:'#f97316' },
  'Quality Issue': { bg:'#fef2f2', color:'#ef4444', border:'#ef4444' },
  'Delay Reason': { bg:'#fffbeb', color:'#f59e0b', border:'#f59e0b' },
  'General': { bg:'#f3f4f6', color:'#6b7280', border:'#d1d5db' },
};

export function Badge({ label, color = '#6b7280', bg = '#f3f4f6' }) {
  return <span style={{ background:bg, color, padding:'3px 9px', borderRadius:20, fontSize:11, fontWeight:500 }}>{label}</span>;
}

export function Field({ label, value, onChange, placeholder, type='text', required=false, style={} }) {
  return (
    <div style={style}>
      <label style={S.label}>{label}{required && ' *'}</label>
      <input type={type} value={value||''} onChange={e => onChange(e.target.value)}
        placeholder={placeholder||''} style={S.input} />
    </div>
  );
}

export function Select({ label, value, onChange, options, required=false, style={} }) {
  return (
    <div style={style}>
      <label style={S.label}>{label}{required && ' *'}</label>
      <select value={value||''} onChange={e => onChange(e.target.value)} style={S.input}>
        {options.map(o => typeof o === 'string'
          ? <option key={o} value={o}>{o}</option>
          : <option key={o.value} value={o.value}>{o.label}</option>
        )}
      </select>
    </div>
  );
}


// Date formatting utility — used everywhere in the app
export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const day = d.getDate();
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const month = months[d.getMonth()];
  const year = String(d.getFullYear()).slice(2);
  return `${day} ${month}'${year}`;
}

export function formatDateShort(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${String(d.getFullYear()).slice(2)}`;
}

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  const today = new Date(); today.setHours(0,0,0,0);
  return Math.ceil((d - today) / (1000*60*60*24));
}
